import {
  Modal,
  Avatar,
  TypographyStylesProvider,
  Divider,
  CloseButton,
} from '@mantine/core'
import dayjs from 'dayjs'

import { useQuery } from '@redwoodjs/web'

import DNButton from 'src/components/Buttons/Button/DNButton'
import AttachmentsRow from 'src/components/Notifications/Components/AttachmentsRow'
import { useEmailModalContext } from 'src/context/EmailModalContext'
import { useReadOnlyEmailModalContext } from 'src/context/ReadOnlyEmailModalContext'
import { GET_EMAIL_THREAD_BY_ID } from 'src/graphql/emails.graphql'

const ReadEmailModal = () => {
  const { handleOpen: openEmailModal } = useEmailModalContext()
  const { opened, handleClose, emailThreadId, selectedEmailId } =
    useReadOnlyEmailModalContext()

  const { data, loading: _loading } = useQuery(GET_EMAIL_THREAD_BY_ID, {
    variables: {
      emailThreadId,
    },
    skip: !emailThreadId,
  })

  // Emails come back newest-first. Show the one the caller clicked; without a
  // selection (or if it has since been removed) fall back to the latest, which
  // is what the thread's list row previews.
  const emails = data?.getEmailThreadById?.emails ?? []
  const emailThread =
    emails.find((email) => email.emailId === selectedEmailId) ?? emails[0]

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      size="70%"
      stackId="read-email-modal"
      withCloseButton={false}
      centered
      overlayProps={{
        backgroundOpacity: 0.2,
        blur: 5,
      }}
      classNames={{
        title: 'font-semibold',
        body: 'flex flex-col gap-2 overflow-y-auto h-full p-6',
        content: 'h-[80vh]',
      }}
    >
      <div className="flex h-full min-h-0 w-full flex-1 flex-col gap-4 overflow-auto">
        <div className="mb-2 flex w-full flex-row items-center justify-start gap-4 text-sm text-doubleNickel-gray-700">
          <Avatar color="blue">
            {emailThread?.applicant?.firstName?.charAt(0)}
            {emailThread?.applicant?.lastName?.charAt(0)}
          </Avatar>
          <div className="flex flex-col gap-1">
            <div className="flex flex-row items-baseline gap-1">
              <div className="text-base font-semibold">
                {emailThread?.applicant?.firstName}{' '}
                {emailThread?.applicant?.lastName}
              </div>
              <div className="text-xs">{emailThread?.to?.join(', ')}</div>
            </div>
            <div className="flex flex-row items-baseline gap-2">
              <div className="text-xs">
                from: {emailThread?.employee?.firstName}{' '}
                {emailThread?.employee?.lastName}
              </div>
              <div className="text-xs">{emailThread?.from}</div>
            </div>
          </div>

          <div className="ml-auto flex flex-row items-center gap-2 text-xs text-doubleNickel-gray-500">
            {dayjs(emailThread?.date).format('MM/DD/YYYY, h:mm A')}
            <CloseButton onClick={handleClose} />
          </div>
        </div>
        <Divider />
        <div className=" py-3 text-lg font-medium ">{emailThread?.subject}</div>

        <TypographyStylesProvider className="">
          <div
            className="text-sm"
            dangerouslySetInnerHTML={{
              __html: emailThread?.body,
            }}
          />
        </TypographyStylesProvider>
        <div className="mt-auto flex flex-col gap-4">
          {emailThread?.attachments && emailThread?.attachments?.length > 0 && (
            <AttachmentsRow
              attachments={emailThread?.attachments}
              applicantId={emailThread?.applicant?.applicantId}
            />
          )}
          <Divider />
          <div className="flex flex-row items-center gap-2">
            <DNButton
              variant="outline"
              onClick={() => {
                handleClose()
                openEmailModal({
                  applicantId: emailThread?.applicant?.applicantId,
                  defaultTo: emailThread?.to?.[0],
                })
              }}
            >
              Email {emailThread?.applicant?.firstName}{' '}
              {emailThread?.applicant?.lastName}
            </DNButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ReadEmailModal
